<template>
  <div data-v-7a569d0e="" data-v-2ac6a5fc="" class="modifyPayPassword member">
    <form data-v-7a569d0e="">
      <div data-v-7a569d0e="" class="list">
        <div data-v-7a569d0e="" class="form-group-wrap">
          <div data-v-7a569d0e="" class="form-group">
            <label data-v-7a569d0e="">您的姓名</label>
            <div data-v-7a569d0e="" class="input-group">
              <input data-v-7a569d0e="" :value="$store.state.userInfo.realname" type="text"  disabled placeholder="请输入您的姓名" />
            </div>
          </div>
          <div data-v-7a569d0e="" class="error-message" style="display: none"></div>
        </div>
        <div data-v-7a569d0e="" class="form-group-wrap">
          <div data-v-7a569d0e="" class="form-group">
            <label data-v-7a569d0e="">联系方式</label>
            <div data-v-7a569d0e="" class="input-group">
              <input data-v-7a569d0e="" v-model="mobile" type="text" placeholder="请输入您的联系方式"  />
            </div>
          </div>
          <div data-v-7a569d0e="" class="error-message" style="display: none"></div>
        </div>
        <div data-v-7a569d0e="" class="form-group-wrap">
          <div data-v-7a569d0e="" class="form-group">
            <label data-v-7a569d0e="" for="usdtAccountNo">申请理由</label>
            <div data-v-7a569d0e="" class="input-group">
              <input data-v-7a569d0e="" v-model="apply_info" type="textarea" placeholder="请输入申请理由"  />
            </div>
          </div>
          <div data-v-7a569d0e="" class="error-message" style="display: none"></div>
        </div>
      </div>
      <a data-v-7a569d0e="" class="form-button" @click="isOk">确认</a>
    </form>
    <div data-v-7a569d0e="" class="pay-dialog" style="display: none">
      <div data-v-7a569d0e="" slot="alertContent" class="pay-password">
        <div data-v-7a569d0e="" class="pay-password__header">提示</div>
        <p data-v-7a569d0e="" class="pay-password__title"><span data-v-7a569d0e="">请您先绑定手机号后，再设置资金密码</span></p>
        <div data-v-7a569d0e=""><a data-v-7a569d0e="" href="javascript:void (0);" class="pay-password__button">前往设置</a></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'applyagent',
  data() {
    return {
     mobile: null,
      apply_info: null,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    isOk() {
      let that = this;
      let info = { mobile: that.mobile, apply_info: that.apply_info };
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      if (!that.apply_info) {
        that.$parent.showTost(0, '请输入申请理由');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/applyagentdo', info)
        .then(res => {
            that.$parent.showTost(1, res.message);
            that.shenqing = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-7d43975c.12f60d5e.css';
</style>



// WEBPACK FOOTER //
// src/components/main/applyagent.vue